// 评分列表
export const comments = ['优', '良', '中', '差'];

// 根据分数，输出当前评分
export function commentsLevel(score) {
  if (score <= 100 && score >= 0) {
    if (score >= 85) {
      return comments[0];
    } else if (score > 75) {
      return comments[1];
    } else if (score >= 60) {
      return comments[2];
    } else {
      return comments[3];
    }
  } else {
    return '';
  }
}
